module.exports = __webpack_public_path__ + "static/media/send_white.465ad78e.png";